<template>
  <div class="content" id="invoice-detail">
    <ResultsHeader :title="data.invoice_number"/>
    <div class="results-main">
      <InvoicesDetailTable v-if="!isBusy" :data="data" />
      <LoadingBlock v-else />
      <BackButton />
    </div>
  </div>
</template>
<script>

import {getAPI} from "@/utils/useApi";
import {onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import { useStore } from 'vuex'
import ResultsHeader from "@/app/Components/ResultsHeader";
import InvoicesDetailTable from "@/app/Components/InvoicesDetailTable";
import LoadingBlock from "@/app/Components/LoadingBlock";
import BackButton from "@/app/Components/BackButton";

export default {
  name: 'InvoiceDetail',
  components: {
    BackButton,
    LoadingBlock,
    InvoicesDetailTable,
    ResultsHeader,
  },
  computed: {
    isBusy() {
      return this.$store.getters.getIsBusy;
    },
  },
  setup() {
    const data = ref([]);
    const route = useRoute();
    const store = useStore();
    const uuid = route.params.id;

    // Fetch data
    onMounted(async () => {
      store.commit('setBusy');

      getAPI('/api/invoices/' + uuid)
          .then((response) => {
            data.value = response.data
            store.commit('clearBusy');
          })
          .catch((error) => {
            // TODO Error handling
            console.log(error);
            store.commit('clearBusy');
          });
    });

    return {
      data,
    }
  }
};

</script>
<style lang="scss">
#invoice-detail {
  min-height: calc(100vh - 5rem);
  background: $darker-gray;

  .results-main {
    padding: 2em;
  }
}
</style>

